import { ID_VERIFICAITON_OFF } from './constants';

export const getIsIdVerificationEnabled = (idVerificationVariant: number) =>
  idVerificationVariant > ID_VERIFICAITON_OFF;
